import React from 'react';

const AppContext = React.createContext();

export default AppContext;


// WEBPACK FOOTER //
// ./src/components/AppProvider/AppContext.js